import React from 'react';
import { Controller } from 'react-hook-form';
import InputField from '../../../CustomInputs/InputField';
import useCreateUser from '../../../../hooks/Payment/useCreateUser';

const Step2 = ({ onPrev, onNext, formProps, setUserId }) => {
  const { createUser, loading, error } = useCreateUser();
  const { control, errors, trigger, watch } = formProps;
  const userDetails = watch();

  const handleNextStep = async () => {
    const isValid = await trigger();
    if (isValid) {
      try {
        const userResp = await createUser({
          firstName: userDetails.firstName,
          lastName: userDetails.lastName,
          cellPhone: userDetails.phone,
          address: userDetails.address,
          city: userDetails.city,
          docType: userDetails.documentType,
          docNumber: userDetails.documentNumber,
          email: userDetails.email,
          fromTitan: true,
        });
        if (userResp.success) {
          setUserId(userResp.userId);
          onNext();
        } else {
          console.error('Error creando el usuario:', userResp.message);
        }
      } catch (err) {
        console.error('Error creando el usuario:', err);
      }
    }
  };
  return (
    <div className='data-container'>
      <h2>Datos personales</h2>

      <InputField
        name='email'
        control={control}
        placeholder='Correo'
        rules={{ required: 'El correo es requerido' }}
        type='email'
      />

      <InputField
        name='firstName'
        control={control}
        placeholder='Nombre'
        rules={{ required: 'El nombre es requerido' }}
      />

      <InputField
        name='lastName'
        control={control}
        placeholder='Apellido'
        rules={{ required: 'El apellido es requerido' }}
      />

      <div className='form-group document'>
        <label htmlFor='documentType'>Documento</label>
        <Controller
          name='documentType'
          control={control}
          defaultValue='CC'
          rules={{ required: 'El tipo de documento es requerido' }}
          render={({ field, fieldState: { error } }) => (
            <>
              <select {...field}>
                <option value='CC'>CC</option>
                <option value='TI'>TI</option>
                <option value='CE'>CE</option>
                <option value='PP'>PP</option>
              </select>
              {error && <p className='error-msg'>{error.message}</p>}
            </>
          )}
        />
        <Controller
          name='documentNumber'
          control={control}
          defaultValue=''
          rules={{ required: 'El número de documento es requerido' }}
          render={({ field, fieldState: { error } }) => (
            <>
              <input
                type='text'
                placeholder='Número de Documento'
                {...field}
                maxLength='10'
                className={error ? 'input-error' : ''}
              />
              {error && <p className='error-msg'>{error.message}</p>}
            </>
          )}
        />
      </div>
      <Controller
        name='termsAccepted'
        control={control}
        rules={{ required: 'Debes aceptar los términos y condiciones.' }}
        render={({ field }) => (
          <div className='form-group terms'>
            <label>
              <input
                type='checkbox'
                {...field}
              />
              Acepto los{' '}
              <a
                href='https://docs.google.com/document/d/e/2PACX-1vRxNMIb79GUH5crhif3_0tf86LRF8ya3EvCHk9KaKjrmaIQkTmerJK77m4YPTOGnQ/pub'
                target='_blank'
                rel='noopener noreferrer'>
                términos y condiciones
              </a>{' '}
              y la{' '}
              <a
                href='https://docs.google.com/document/d/e/2PACX-1vQAHdcqEsBdWYxpAXCWWTDBvl2AQxXAZE_qdxIaO7cfRE0Y7DR8VcvhBIERTHKvHQ/pub'
                target='_blank'
                rel='noopener noreferrer'>
                política de tratamiento de datos
              </a>
              .
            </label>
            {errors.termsAccepted && (
              <p className='error-msg'>{errors.termsAccepted.message}</p>
            )}
          </div>
        )}
      />

      <div className='controls'>
        <button
          type='button'
          onClick={onPrev}
          className='btn primary'>
          Anterior
        </button>
        <button
          type='button'
          className='btn primary'
          onClick={handleNextStep}
          disabled={loading}>
          {loading ? 'Creando usuario' : 'Siguiente'}
        </button>
      </div>
      {error && <p className='error-msg'>{error}</p>}
    </div>
  );
};

export default Step2;
